export interface ModelDetailedResult151Payload {
  id?: number;
  servicesToEmployeeId?: number;
  incomeDetailsSummaryId?: number;
  generalTaxableBase?: number;
  savingsTaxableBase?: number;
  generalFullAmountDue?: number;
  savingsFullAmountDue?: number;
  totalFullAmountDue?: number;
  deductionDonation?: number;
  foreignTaxCredit?: number;
  amountDueLaw?: number;
  withholdingPayments?: number;
  previousDepositRefund?: number;
  taxRefundSta?: number;
  nonTaxResidentDuePaid?: number;
  sectionA1?: number;
  sectionA2?: number;
  sectionB?: number;
  sectionC?: number;
  sectionD?: number;
  sectionE1E2?: number;
  totalSectionA1?: number;
  totalSectionA2?: number;
  totalSectionB?: number;
  totalSectionC?: number;
  totalSectionD?: number;
  totalSectionE1E2?: number;
  totalCapitalGain?: number;
  totalSectione1?: number;
  resultSelfAssessment?: number;
  nrc?: string;
  selfAssessPersonRepresentativeId?: number;
  modelBankAccountInformationId?: number;
  modelDomicilesInformationId?: number;
  supplementary?: string;
  devoRenuncia?: string;
  justificantNumber?: string;
  modelDetailedResultStatus?: string;
  declarationType?: string;
  restIncomeA1?: number;
  restIncomeA2?: number;
  restIncomeB?: number;
  restIncomeC?: number;
  restIncomeD?: number;
  restIncomeE1?: number;
  restIncomeE1E2?: number;
  restRetentionA1?: number;
  restRetentionA2?: number;
  restRetentionB?: number;
  restRetentionC?: number;
  restRetentionD?: number;
  restRetentionE1?: number;
  restRetentionE1E2?: number;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  return String(value);
}

function toStatus(value: unknown): string | undefined {
  if (value && typeof value === 'object' && 'nameEn' in (value as Record<string, unknown>)) {
    return toStringValue((value as Record<string, unknown>).nameEn);
  }
  return toStringValue(value);
}

export function buildModelDetailedResult151Payload(input: any): ModelDetailedResult151Payload {
  const payload: ModelDetailedResult151Payload = {};
  const mutablePayload = payload as Record<string, unknown>;

  const numberFields: Array<keyof ModelDetailedResult151Payload> = [
    'id',
    'servicesToEmployeeId',
    'incomeDetailsSummaryId',
    'generalTaxableBase',
    'savingsTaxableBase',
    'generalFullAmountDue',
    'savingsFullAmountDue',
    'totalFullAmountDue',
    'deductionDonation',
    'foreignTaxCredit',
    'amountDueLaw',
    'withholdingPayments',
    'previousDepositRefund',
    'taxRefundSta',
    'nonTaxResidentDuePaid',
    'sectionA1',
    'sectionA2',
    'sectionB',
    'sectionC',
    'sectionD',
    'sectionE1E2',
    'totalSectionA1',
    'totalSectionA2',
    'totalSectionB',
    'totalSectionC',
    'totalSectionD',
    'totalSectionE1E2',
    'totalCapitalGain',
    'totalSectione1',
    'resultSelfAssessment',
    'selfAssessPersonRepresentativeId',
    'modelBankAccountInformationId',
    'modelDomicilesInformationId',
    'restIncomeA1',
    'restIncomeA2',
    'restIncomeB',
    'restIncomeC',
    'restIncomeD',
    'restIncomeE1',
    'restIncomeE1E2',
    'restRetentionA1',
    'restRetentionA2',
    'restRetentionB',
    'restRetentionC',
    'restRetentionD',
    'restRetentionE1',
    'restRetentionE1E2',
  ];

  for (const field of numberFields) {
    const value = toNumber(input?.[field]);
    if (value !== undefined) {
      mutablePayload[field] = value;
    }
  }

  const status = toStatus(input?.modelDetailedResultStatus);
  if (status !== undefined) {
    payload.modelDetailedResultStatus = status;
  }

  const stringFields: Array<keyof ModelDetailedResult151Payload> = [
    'nrc',
    'supplementary',
    'devoRenuncia',
    'justificantNumber',
    'declarationType',
  ];

  for (const field of stringFields) {
    const value = toStringValue(input?.[field]);
    if (value !== undefined) {
      mutablePayload[field] = value;
    }
  }

  return payload;
}
